var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("footer", { staticClass: "footer" }, [
    _c("img", {
      staticClass: "cat-img",
      attrs: { src: require("@/assets/img/icon/cat.png"), alt: "cat" },
    }),
    _c("ul", [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _c("li", [
        _c(
          "a",
          { staticClass: "link", attrs: { href: _vm.help, target: "_blank" } },
          [_vm._v("ヘルプ/お問い合わせ")]
        ),
      ]),
    ]),
    _c("small", { staticClass: "small" }, [_vm._v("© 2018 indent")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c(
        "a",
        { staticClass: "link", attrs: { href: "/terms", target: "_blank" } },
        [_vm._v("利用規約")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c(
        "a",
        { staticClass: "link", attrs: { href: "/privacy", target: "_blank" } },
        [_vm._v("プライバシーポリシー")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "link",
          attrs: {
            href: "/specifiedCommercialTransactionsAct",
            target: "_blank",
          },
        },
        [_vm._v("特定商取引法")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "/paymentServicesAct", target: "_blank" },
        },
        [_vm._v("資金決済法")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }